<template>
  <CoreDialog
    data-qa="patient-profile-modal"
    class="patient-profile-modal"
    :value="isVisible"
    :title="`${t('Пациент', options)} ${patientData.title}`"
    transition="fade-transition"
    size="fullscreen"
    divider
    persistent
    hide-overlay
  >
    <template #prependBtn="{ btnProps }">
      <v-btn
        v-bind="btnProps"
        @click="isOpened = false"
      >
        <span class="ui-icon-close-not-a-circle" />
      </v-btn>
    </template>

    <PatientProfileModalSkeleton
      v-if="!patientData || !patientData.isLoaded"
    />
    <template v-else>
      <div class="text-subtitle-1 mb-6">
        {{ t('Доверие к профилю', options) }}
      </div>
      <PatientProfileTrustInfo
        :trust-percent="patientData.trust_percent"
        :can-trust="patientData.can_trust"
        class="mb-6"
      />
      <PatientProfileCriteria
        class="mb-10"
        :criteria="patientData.trust_criteria"
      />
      <PatinetProfileRatesStatistic
        class="mb-10"
        :count-canceled="patientData.count_rates_canceled"
        :count-negative="patientData.count_rates_negative"
        :count-positive="patientData.count_rates_positive"
        :count-without-mark="patientData.count_rates_without_mark"
      />

      <div class="d-flex justify-space-between text--text text-subtitle-1">
        <span class="mr-4">
          {{ t('Записи на приём через', options) }} <br> {{ isYDoc ? 'YDoc' : 'Продокторов' }}
        </span>
        <span data-qa="patient_profile_count_appointments">
          {{ patientData.count_appointments || t('Нет', options) }}
        </span>
      </div>
    </template>
    <template #actions>
      <v-btn
        data-qa="modal-actions-btn-close"
        color="primary"
        block
        depressed
        @click="isOpened = false"
      >
        {{ t('Закрыть', options) }}
      </v-btn>
    </template>
  </CoreDialog>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import getUserLanguage from 'src/utils/getUserLanguage'
import scrollLock from 'src/utils/scrollLock'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import PatinetProfileRatesStatistic from 'www/vue_components/common/PatientProfile/components/common/PatinetProfileRatesStatistic.vue'
import PatientProfileModalSkeleton from 'www/vue_components/common/PatientProfile/components/common/PatientProfileModalSkeleton.vue'
import PatientProfileCriteria from 'www/vue_components/common/PatientProfile/components/common/PatientProfileCriteria.vue'
import { computed, watch } from 'vue'
import PatientProfileTrustInfo from 'www/vue_components/common/PatientProfile/components/common/PatientProfileTrustInfo.vue'

const props = defineProps<{
  isVisible: boolean
  patientData: {
    id: number | null
    title: string
    isLoaded: boolean
    count_rates_positive: number
    count_rates_negative: number
    count_rates_canceled: number
    count_rates_without_mark: number
    count_appointments: number
    trust_criteria: Array<{
      can_trust: boolean
      title: string
    }>
    can_trust: boolean
    trust_percent: number
  }
}>()

type Emits = {
  (_event: 'modal:close'): void,
}

const emit = defineEmits<Emits>()

const options = { ns: getUserLanguage() }
const { t } = I18NextVue
const isYDoc = window.IS_YDOC
const isOpened = computed({
  get() {
    return props.isVisible
  },
  set(value) {
    if (!value) {
      emit('modal:close')
    }
  },
})

watch(() => props.isVisible, value => {
  scrollLock.set(value)
})
</script>

<style lang="scss" scoped>
.patient-profile-modal {
  // z-index необходим для того, чтобы vue-модалка 'профиль пациента',
  // которая монтируется в первый попавшийся VApp, перекрывала модалку с отзывами
  z-index: 1005;
}
</style>
